import React from 'react';
import { Badge } from '@superops/ui-design-system';

interface PatchStatuses {
  [key: string]: string;
}

interface CellProps {
  value: string;
}

interface AssetPatchStatusProps {
  cell: CellProps;
}

function getPatchStatusBadge(patch: string) {
  const badgeVariants: PatchStatuses = {
    'Reboot Required': 'warning',
    'Install Pending': 'warning',
    'Fully Patched': 'success'
  };
  /** For No Policy and No Data, set the default view(grey backgroud) */
  return badgeVariants[patch] || '';
}

function AssetPatchStatusCell(props: AssetPatchStatusProps) {
  const { cell } = props;

  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <div className="uppercase">
      <Badge status={getPatchStatusBadge(cell.value)} large>
        {cell.value || 'NA'}
      </Badge>
    </div>
  );
}

export default AssetPatchStatusCell;
